import { getSpotConfig, getV1Config } from '@host-panel/request/config';

export async function getAutoPendingConfig(spotId: string) {
  return getV1Config(spotId, [
    'auto_pend_message_reports_enabled',
    'auto_pend_message_reports_threshold'
  ]);
}
